/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type AdminTalentPoolCreateRequestColor = typeof AdminTalentPoolCreateRequestColor[keyof typeof AdminTalentPoolCreateRequestColor] | null;


export const AdminTalentPoolCreateRequestColor = {
  gray: 'gray',
  red: 'red',
  orange: 'orange',
  amber: 'amber',
  yellow: 'yellow',
  green: 'green',
  teal: 'teal',
  cyan: 'cyan',
  blue: 'blue',
  indigo: 'indigo',
  violet: 'violet',
  pink: 'pink',
} as const;
